import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Textarea } from "./textarea";
import { cn } from "app/lib/utils";

interface AutoExpandTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const AutoExpandTextarea = forwardRef<
  HTMLTextAreaElement,
  AutoExpandTextareaProps
>(({ className, onChange, ...props }, ref) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useImperativeHandle(ref, () => textareaRef.current!);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  };

  useEffect(() => {
    adjustHeight();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    adjustHeight();
    onChange?.(e);
  };

  return (
    <Textarea
      ref={textareaRef}
      className={cn("resize-none overflow-hidden", className)}
      onChange={handleChange}
      {...props}
    />
  );
});

AutoExpandTextarea.displayName = "AutoExpandTextarea";

export { AutoExpandTextarea };
